<template>
  <div class="appointment">
    <div class="sub-box">
      <a @click="close" class="btn-return">< 返回</a>
        <div class="tit-sub">
          <h3>我的预约清单</h3>
        </div>
        <div class="appointment-con">   

            <div class="appointment-item">
              <h4>已预约的名校招生答疑</h4>
              <div class="appointment-info">
                <dl class="dlist1 fix">
                  <dt>
                    <img src="@/assets/images/live_head.png" alt />
                    <a href="#">立即面试</a>
                  </dt>
                  <dd>
                    <h5>高璨然</h5>
                    <b>服务项目：XXXXXXXXX</b>
                    <p class="ofw-hide-5">Duolingo资深教师，英国布里斯托大学教育学硕士，美国ETS官方认证教师，启德考培资深教师培训师，雅思写作高级培训师，
                      GRE/GMAT资深教师，英语专业八级，8年教学经验，教学课时上万。</p>
                  </dd>
                </dl>
                <dl class="dlist2 fix">
                  <dt><img src="@/assets/images/sub/school_logo.png" alt /></dt>
                  <dd>
                    伦敦政治与经济学院
                  </dd>
                </dl>
              </div>
            </div>

            <div class="appointment-item">
              <h4>已预约的留学大咖</h4>
              <div class="appointment-info">
                <dl class="dlist1 fix">
                  <dt>
                    <img src="@/assets/images/live_head.png" alt />
                    <a href="#">立即面试</a>
                  </dt>
                  <dd>
                    <h5>高璨然</h5>
                    <b>服务项目：XXXXXXXXX</b>
                    <p class="ofw-hide-5">Duolingo资深教师，英国布里斯托大学教育学硕士，美国ETS官方认证教师，启德考培资深教师培训师，雅思写作高级培训师，
                      GRE/GMAT资深教师，英语专业八级，8年教学经验，教学课时上万。</p>
                  </dd>
                </dl>
              </div>
            </div>
        </div>
    </div>
    <!-- 底部导航 -->
    <Footer style="margin-bottom:0" />
  </div>
</template>

<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  data() {
    return {};
  },
  computed: {},
  methods: {
    close() {
      this.$router.go(-1);
    }
  },
  mounted(){
    window.scrollTo(0, 0)
  }
};
</script>

<style scoped>
.appointment-con {
  background: url(~@/assets/images/sub/list_bg.png) repeat-y;
  background-size: 100% auto;
  padding: 0.2rem 0.15rem 0.5rem;
  border-radius: 0 0 0.22rem 0.22rem;
  min-height: 4rem;
}
.appointment-item{ 
  margin-bottom: 0.5rem;
}
.appointment-item h4{ 
   width: 3.86rem;
   height: 0.55rem;
   background: url(~@/assets/images/sub/list_tit2.png) repeat-y;
   background-size: 100% auto;
   line-height: 0.55rem;
   font-size: 0.26rem;
   text-align: center;
   color: #fff;
   font-weight: 700;
   margin: 0 auto;
}
.appointment-info {
  width:100%;
  min-height: 3.2rem;
  padding: 0 0.2rem;
  background: #fff;
  border-radius:0.24rem;
  padding-bottom: 0.4rem;
}
.appointment-info .dlist1 { 
  padding: 0.35rem 0 0.2rem; 
}
.appointment-info .dlist1 dt { 
  width: 1.64rem; 
  height: 2.3rem;
  float: left; 
  background: url(~@/assets/images/sub/appoint_bg.png) repeat-y;
  background-size: 100% auto;
  margin: 0.2rem 0.3rem 0.1rem 0 
}
.appointment-info .dlist1 dt img {
  width: 1.48rem;
  height: 1.48rem;
  display: block;
  border-radius:0.72rem;
  background: #f0f3f7;
  overflow: hidden;
  margin:0.1rem auto;
}
.appointment-info .dlist1 dt a {
  width: 1.48rem;
  height: 0.36rem;
  display: block;
  margin: 0 auto;
  background: #4da2da;
  color: #fff;
  text-align: center;
  font-size: 0.24rem;
  border-radius: 0.18rem;
}
.appointment-info .dlist1 dd {
  width: 4.1rem;
  float: left;
  position: relative;
}
.appointment-info .dlist1 dd h5 {
  height: 0.28rem;
  font-size: 0.28rem;
  line-height: 0.28rem;
  font-weight: 700;
  color: #332d5c;
  margin-bottom: 0.02rem;
  border-left: 0.03rem solid #e9a63a;
  padding-left:0.09rem;
  margin-left: -0.12rem;
}
.appointment-info .dlist1 dd b {
  font-size: 0.24rem;
  font-weight: 400;
  display:block;
  color: #332d5c;
  padding: 0.06rem 0;
  border-bottom: 0.01rem solid #8c9dc8;
  padding-right: 0.4rem;
  margin-bottom: 0.1rem;
}
.appointment-info .dlist1 dd p {
  color: #5e5e5e;
  font-size: 0.22rem;
}
.appointment-info .dlist2 {
  min-height: 0.7rem; 
  padding: 0.1rem; 
  background: #6fc1cf;
  border-radius: 0.1rem;
}
.appointment-info .dlist2 dt {
  width: 1.44rem;
  height: 0.48rem;
  float: left;
  background: #fff;
  border:1px solid #dcdcdc;
  border-radius: 0.1rem;
  text-align: center;
  margin-right:0.4rem ;
  
}
.appointment-info .dlist2 dt img {
  display:inline-block;
  width: auto;
  height: 100%;
}
.appointment-info .dlist2 dd {
  width: 3.9rem;
  height: 0.26rem;
  float: left;
  border-left:3px solid #fff152;
  padding-left: 0.18rem;
  margin-top: 0.14rem;
  line-height: 0.26rem;
  font-size: 0.24rem;
  color: #fff;
}

.prize .tc-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
}

.prize .tc {
  width: 6.2rem;
  height: 3.58rem;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  padding: 0.1rem 0.3rem 0;
  border-radius: 0.2rem;
  text-align: center;
}
.prize .tc .close {
  width: 0.32rem;
  height: 0.28rem;
  position: absolute;
  right: 0;
  top: 0;
}

.prize .tc .qycj_succ_dh {
  width: 0.78rem;
  height: 0.78rem;
  display: block;
  margin: 0 auto 0.24rem;
}
.prize .tc h4 {
  font-size: 0.4rem;
}
.prize .tc h6 {
  font-weight: 900;
  font-size: 0.4rem;
  color: #ff5156;
  padding: 0.1rem 0;
}
.prize .tc p {
  font-size: 0.26rem;
  padding-top: 0.1rem;
}
</style>
